import axios from 'axios';
import { API } from './constants';

const api = axios.create({ baseURL: API, headers: { 'Content-Type': 'application/json' }, withCredentials: true });

export const seedData = () => api.post('/seed');
export const getUser = () => api.get('/user');
export const updateUser = (data) => api.put('/user', data);
export const completeOnboarding = () => api.put('/user/onboard');

export const getDebts = () => api.get('/debts');
export const createDebt = (data) => api.post('/debts', data);
export const updateDebt = (id, data) => api.put(`/debts/${id}`, data);
export const deleteDebt = (id) => api.delete(`/debts/${id}`);
export const payoffDebt = (id) => api.post(`/debts/${id}/payoff`);
export const setTargetDebt = (id) => api.post(`/debts/${id}/target`);

export const getPayments = () => api.get('/payments');
export const createPayment = (data) => api.post('/payments', data);

export const getBadges = () => api.get('/badges');

export const sendCoachMessage = (sessionId, text) => api.post('/coach/chat', { session_id: sessionId, text });
export const getCoachHistory = (sessionId) => api.get(`/coach/history/${sessionId}`);
export const getSpendingAnalysis = () => api.get('/coach/spending-analysis');

export const getStrategy = () => api.get('/strategy');
export const updateStrategy = (data) => api.put('/strategy', data);
export const calculatePayoff = () => api.get('/strategy/calculate');

export const getRoundUps = () => api.get('/roundups');
export const updateRoundUps = (data) => api.put('/roundups', data);
export const applyRoundUps = () => api.post('/roundups/apply');

export const getSpending = () => api.get('/spending');
export const getBudget = () => api.get('/budget');
export const updateBudget = (data) => api.put('/budget', data);

export const getNotifications = () => api.get('/notifications');
export const updateNotifications = (data) => api.put('/notifications', data);

export const getReferral = () => api.get('/referral');
export const getBankStatus = () => api.get('/bank/status');
export const connectBank = (data) => api.post('/bank/connect', data);
export const syncBank = () => api.post('/bank/sync');
export const getBankAccounts = () => api.get('/bank/accounts');
export const getBankTransactions = (limit = 50) => api.get(`/bank/transactions?limit=${limit}`);
export const disconnectBank = () => api.post('/bank/disconnect');

export const createPremiumCheckout = (originUrl) => api.post('/premium/checkout', { origin_url: originUrl });
export const getPremiumStatus = (sessionId) => api.get(`/premium/status/${sessionId}`);
export const confirmPremium = (sessionId) => api.get(`/premium/confirm/${sessionId}`);

export const exportData = (type) => api.post(`/export/${type}`);

// Social
export const getLeaderboard = () => api.get('/social/leaderboard');
export const getFriendActivity = () => api.get('/social/activity');
export const postActivity = (data) => api.post('/social/activity', data);

// Points & Streaks
export const getPoints = () => api.get('/points');
export const awardPoints = (action, description) => api.post('/points/award', { action, description });

// Recurring Payments
export const getRecurring = () => api.get('/recurring');
export const createRecurring = (data) => api.post('/recurring', data);
export const updateRecurring = (id, data) => api.put(`/recurring/${id}`, data);
export const deleteRecurring = (id) => api.delete(`/recurring/${id}`);

// AI Categorization
export const categorizeTransactions = () => api.post('/transactions/categorize');
export const checkSpendingBadges = () => api.post('/badges/check-spending');

// Bank Auto Sync
export const autoSyncBanks = () => api.post('/bank/auto-sync');

// Theme
export const getPreferences = () => api.get('/user/preferences');
export const updatePreferences = (data) => api.put('/user/preferences', data);

// Push Notifications
export const subscribePush = (subscription) => api.post('/push/subscribe', { subscription });
export const unsubscribePush = (endpoint) => api.post('/push/unsubscribe', { endpoint });
export const sendTestPush = () => api.post('/push/send-test');

// Custom Strategy
export const setCustomOrder = (order) => api.put('/strategy/custom-order', { order });

// Streak Tracker
export const getStreaks = () => api.get('/streaks');
export const logPaymentMonth = (data) => api.post('/streaks/log-payment', data);

// BATCH 7: Delete Account
export const deleteAccount = () => api.delete('/auth/delete-account');
export const setPassword = (new_password) => api.post('/auth/set-password', { new_password });
